import React from 'react';
import { FormattedMessage } from 'react-intl';

const tariffLabel = (id) => <FormattedMessage id={'app.billingprices.tariff'} values={{ number: id }} />;

export const billlingPricesColumns = {
  state: {
    id: 'state',
    label: <FormattedMessage id={'app.billingprices.state'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '80px',
  },
  contractNumber: {
    id: 'contractNumber',
    label: <FormattedMessage id={'app.billingprices.contractNumber'} />,
    options: {
      sortable: true,
    },
    width: '110px',
  },
  organization: {
    id: 'organizationName',
    label: <FormattedMessage id={'app.billingprices.organization'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '150px',
  },
  frameContract: {
    id: 'frameContract',
    label: <FormattedMessage id={'app.common.frameContract'} />,
    options: {},
    width: '150px',
  },

  currency: {
    id: 'currency',
    label: <FormattedMessage id={'app.contractParameters.contractData.currency'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '100px',
  },

  invoicingCurrency: {
    id: 'invoicingCurrency',
    label: <FormattedMessage id={'app.contractParameters.contractData.invoicingCurrency'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '100px',
  },

  period: {
    id: 'period',
    label: <FormattedMessage id={'app.billingprices.period'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '80px',
  },
  periodMonth: {
    id: 'month',
    label: <FormattedMessage id={'app.billingprices.periodMonth'} />,
    options: {
      filterable: true,
    },
    width: '80px',
  },
  product: {
    id: 'isMonthlyPurchaseAvailable',
    label: <FormattedMessage id={'app.billingprices.product'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '150px',
  },
  commodity: {
    id: 'commodity',
    label: <FormattedMessage id={'app.contracts.commodity'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '70px',
  },
  pnMethod: {
    id: 'purchaseMethod',
    label: <FormattedMessage id={'app.billingprices.pnMethod'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '110px',
  },
  quantity: {
    id: 'quantity',
    label: <FormattedMessage id={'app.billingprices.volume'} />,
    options: {
      sortable: true,
    },
    width: '125px',
    align: 'right',
  },
  percentagePurchasedQuantity: {
    id: 'percentagePurchasedQuantity',
    label: <FormattedMessage id={'app.billingprices.purchasedPercents'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '200px',
    align: 'right',
  },
  purchasedQuantity: {
    id: 'purchasedQuantity',
    label: <FormattedMessage id={'app.billingprices.purchased'} />,
    options: {
      sortable: true,
    },
    width: '160px',
    align: 'right',
  },
  remainingPurchaseQuantity: {
    id: 'remainingPurchaseQuantity',
    label: <FormattedMessage id={'app.billingprices.remaining'} />,
    options: {
      sortable: true,
    },
    width: '120px',
    align: 'right',
  },
  tariff1: {
    id: 'tariff1',
    label: tariffLabel(1),
    options: {
      sortable: false,
    },
    width: '80px',
    align: 'right',
  },
  tariff2: {
    id: 'tariff2',
    label: tariffLabel(2),
    options: {
      sortable: false,
    },
    width: '80px',
    align: 'right',
  },
  tariff3: {
    id: 'tariff3',
    label: tariffLabel(3),
    options: {
      sortable: false,
    },
    width: '80px',
    align: 'right',
  },
  tariff4: {
    id: 'tariff4',
    label: tariffLabel(4),
    options: {
      sortable: false,
    },
    width: '80px',
    align: 'right',
  },
  tariff5: {
    id: 'tariff5',
    label: tariffLabel(5),
    options: {
      sortable: false,
    },
    width: '80px',
    align: 'right',
  },
  tariff6: {
    id: 'tariff6',
    label: tariffLabel(6),
    options: {
      sortable: false,
    },
    width: '80px',
    align: 'right',
  },
};
